<template>
  <div class="culture">
    <section class="main">
      <div class="flex c_item">
        <div class="left">
          <div class="top_title">
            <div class="title1">
              COMPANY
              <br />PROFIL
            </div>
            <div class="title2">企业简介</div>
          </div>
          <p>“粒上皇”品牌创始人潘俊海自1999年与栗结缘，深耕板栗及休闲零食领域二十七载。目前，粒上皇已在北京、上海、广东、四川、安徽、湖南等地开设门店1600多家，成长为集绿色休闲食品研发、智能化精深加工、仓储物流及终端零售于一体的全国优秀连锁品牌。</p>
          <p>品牌在国内外享有较高知名度，已在全球超过100多个国家和地区完成商标注册，并被纳入“广东省重点商标保护名录”。​ 2024年起，粒上皇连续3年蝉联“3·15放心消费品牌”、“重质量守诚信标杆单位”等多项殊荣；并于2025年入选品牌强国先行工程“国货之光”品牌。好口碑源于对极致品质和服务的追求，粒上皇将一直朝着创休闲食品百年民族品牌的企业愿景而迈进，让全世界乐享中华美食。</p>
          <!-- 门店数量数据备注：明确统计时间范围，避免动态调整导致的差异 -->
          <p class="data-note">*门店数据截止至2025年12月统计数据</p>
        </div>
        <div class="right">
          <img class="company_pic" src="../assets/img/newcompany.png" alt />
        </div>
      </div>
      <div class="flex c_item2" id="king1">
        <div class="left">
          <img class="culture_pic" src="../assets/img/culture.png" alt />
        </div>
        <div class="right">
          <div class="top_title">
            <div class="title1">
              COMPANY
              <br />CULTURE
            </div>
            <div class="title2">企业文化</div>
          </div>
          <ul class="culture_list flex">
            <li class="list_l">
              <h5>企业使命</h5>
              <p>让全世界乐享中华美食</p>
              <h5>企业愿景</h5>
              <p>创休闲食品百年民族品牌</p>
              <h5>企业核心价值观</h5>
              <p>感恩、创新、成长、分享</p>
            </li>
            <li class="list_l">
              <h5>企业经营理念</h5>
              <p>品质第一、顾客至上、保持特色、铸就品牌</p>
              <h5>企业人才理念</h5>
              <p>能者上、平者让，庸者下，不拘一格，培养人才</p>
              <h5>企业团队理念</h5>
              <p>一群人、一件事、一辈子</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="develop" id="king2">
        <div class="d_tit">
          <div class="top_title">
            <div class="title1">
              DEVELOPMENT
              <br />HISTORY
            </div>
            <div class="title2">发展历程</div>
          </div>
        </div>
		<div class="companybox">
			<el-image
				:src="historyImg"
				:preview-src-list="historyPreviewList"
				:hide-on-click-modal="true"
				alt="发展历程"
				class="history-img"
			/>
			<!-- 悬浮提示：hover 时淡入，告知用户可点击查看大图 -->
			<div class="view-hint">
				<i class="el-icon-zoom-in"></i>
				<span>点击查看大图</span>
			</div>
		</div>

       <!-- <div class="d_list flex">
          <div class="d_item">
            <img src="../assets/img/history1.png" alt />
            <div class="year">2020</div>
            <p class="txt1">精彩继续...</p>
          </div>
          <div class="d_item">
            <img src="../assets/img/history2.png" alt />
            <div class="year">2019</div>
            <p class="txt1">革精进年。二十年沉淀与深耕，粒上皇深市场规模已覆盖全国49个城市，拥有400+直营门店，成为国内板栗行业的领军品牌</p>
          </div>
          <div class="d_item">
            <img src="../assets/img/history3.png" alt />
            <div class="year">2018</div>
            <p class="txt1">战略升级年。提出新的五年战略规划，重塑公司文化，举办全球首场“栗史博物馆”活动，为实现公司“12489”战略目标坚定迈进；</p>
          </div>
        </div> -->
      </div>
      <!-- 品牌动态 -->
    <!-- <div class="develop">
        <div class="d_tit">
          <div class="top_title">
            <div class="title1">
              NEWS
              <br />INFORMATION
            </div>
            <div class="title2">品牌动态</div>
          </div>
        </div>
        <div class="d_list flex">
          <div class="d_item">
            <img src="../assets/img/news1.png" alt />
            <div class="d_tit">2020年粒上皇加盟政策有哪些变化呢？</div>
            <p class="txt2">粒上皇休闲食品是当下十分热门的零食品牌，并且很多粒上皇门店的生意也都非常火爆，虽然如今市场…</p>
            <div class="time">2019-12-11</div>
          </div>
          <div class="d_item">
            <img src="../assets/img/news2.png" alt />
            <div class="d_tit">开粒上皇加盟店需要做好哪些前期工作?</div>
            <p class="txt2">在零食行业火爆的今天相信很多人都希望自己能够拥有一家火爆的零食店来获取更多的财富，当然还有…</p>
            <div class="time">2019-12-11</div>
          </div>
          <div class="d_item">
            <img src="../assets/img/news3.png" alt />
            <div class="d_tit">2020年粒上皇加盟政策有哪些变化呢？</div>
            <p class="txt2">粒上皇休闲食品是当下十分热门的零食品牌，并且很多粒上皇门店的生意也都非常火爆，虽然如今市场…</p>
            <div class="time">2019-12-11</div>
          </div>
        </div>
      </div> -->

    </section>
  </div>
</template>

<script>
export default {
  data() {
    // 发展历程图片：require 确保 webpack 正确处理静态资源哈希与路径
    const historyImg = require("../assets/img/culture/history.jpg");
    return {
      historyImg,
      // el-image 的 preview-src-list 需要数组格式，点击后以原图全分辨率展示
      historyPreviewList: [historyImg],
    };
  },
  watch: {
    $route(to, from) {
      console.log(this.$route.query.id);
      let id = this.$route.query.id;
      this.scrolls(id);
    }
  },
  methods: {
    scrolls(id) {
      switch (id) {
        case "1":
          document
            .getElementById("king1")
            .scrollIntoView({ behavior: "smooth" });
          break;
        case "2":
          // debugger;
          document.getElementById("king2").scrollIntoView({ behavior: "smooth" });
          break;
      }
    }
  },
  mounted() {
    console.log(this.$route.query.id);
    let id = this.$route.query.id;
    this.scrolls(id);
  }
};
</script>

<style lang="scss" scoped>
.culture {
  .t_pic_box {
    font-size: 0;
  }
  .t_pic {
    width: 100%;
  }
  .c_item {
    width: 1200px;
    margin: 0 auto;
    padding: 103px 0 80px;
    > div {
      flex: 1;
    }
    .left {
      .top_title {
        position: relative;
        text-align: left;
        margin-bottom: 53px;
      }

      .top_title .title1 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        font-family: 'HarmonyOS Sans SC';
        font-size: 60px;
        color: rgba(76, 1, 4, 0.05);
        line-height: 60px;
        text-align: left;
        font-weight: 400;
        margin-bottom: 6px;
      }

      .top_title .title2 {
        font-family: 'HarmonyOS Sans SC';
        font-size: 40px;
        color: #4c0104;
        text-align: left;
        font-weight: 500;
        width: 100%;
        margin-bottom: 13px;
        padding-top: 32px;
        position: relative;
        z-index: 1;
      }
      p {
        width: 520px;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        text-align: justify;
        line-height: 34px;
        text-indent: 33px;
      }
      /* 门店数据备注：小字号灰色，不喧宾夺主 */
      .data-note {
        width: 520px;
        font-size: 12px;
        color: #999999;
        text-indent: 0;
        margin-top: 10px;
      }
    }
    .right {
      .company_pic {
        width: 600px;
        border-radius: 10px;
        box-shadow: 80px 80px 1px #f7f7f7;
      }
    }
  }
  .c_item2 {
    width: 1200px;
    margin: 0 auto;
    padding: 80px 0;
    text-align: left;
    > div {
      flex: 1;
    }
    .right {
      .top_title {
        position: relative;
        text-align: left;
        margin-bottom: 53px;
      }

      .top_title .title1 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        font-family: 'HarmonyOS Sans SC';
        font-size: 60px;
        color: rgba(76, 1, 4, 0.05);
        line-height: 60px;
        text-align: left;
        font-weight: 400;
        margin-bottom: 6px;
      }

      .top_title .title2 {
        font-family: 'HarmonyOS Sans SC';
        font-size: 40px;
        color: #4c0104;
        text-align: left;
        font-weight: 500;
        width: 100%;
        margin-bottom: 13px;
        padding-top: 32px;
        position: relative;
        z-index: 1;
      }
      .culture_list {
        font-size: 16px;
        color: #333333;
        margin-top: 78px;
        li:first-child {
          width: 240px;
        }
        h5 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 8px;
        }
        p {
          margin-bottom: 20px;
        }
      }
    }
    .left {
      .culture_pic {
        width: 500px;
        border-radius: 10px;
        box-shadow: -80px 80px 1px #f7f7f7;
      }
    }
  }
  .develop {
    width: 1200px;
    margin: 80px auto;
    .top_title {
      position: relative;
      text-align: center;
      margin-bottom: 53px;
    }

    .top_title .title1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      font-family: 'HarmonyOS Sans SC';
      font-size: 60px;
      color: rgba(76, 1, 4, 0.05);
      line-height: 60px;
      text-align: center;
      font-weight: 400;
      margin-bottom: 6px;
    }

    .top_title .title2 {
      font-family: 'HarmonyOS Sans SC';
      font-size: 40px;
      color: #4c0104;
      text-align: center;
      font-weight: 500;
      width: 100%;
      margin-bottom: 85px;
      padding-top: 32px;
      position: relative;
      z-index: 1;
    }
    .d_list {
      justify-content: space-between;
      text-align: left;
      > div {
        width: 380px;
      }
      .d_item {
        font-size: 0;
        img {
          width: 380px;
          border-radius: 10px;
        }
        .d_tit {
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #151515;
          line-height: 22px;
          font-weight: 600;
          padding: 24px 0 35px;
        }
      }
      .year {
        font-family: ApercuPro-Medium;
        font-size: 28px;
        color: #333333;
        border-bottom: 1px solid #e6e6e6;
        padding: 16px 0 20px;
      }
      .txt1 {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #7a7a7a;
        letter-spacing: 0;
        line-height: 26px;
        padding: 21px 0;
      }
      .txt2 {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #7a7a7a;
        letter-spacing: 0;
        line-height: 26px;
        padding: 0 0 32px;
      }
      .time {
        font-family: 'HarmonyOS Sans SC';
        font-size: 14px;
        color: #7a7a7a;
        letter-spacing: 0;
        line-height: 26px;
      }
    }
  }
}
.companybox{
	width: 100%;
  overflow: hidden;
  position: relative;  /* 为悬浮提示提供定位上下文 */
  cursor: pointer;     /* 指示图片可点击查看大图 */
}
/* 悬浮查看提示：默认隐藏，hover 时淡入显示 */
.view-hint {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 12px 0;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  text-align: center;
  font-size: 14px;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;  /* 不阻挡 el-image 的点击事件 */
  i {
    margin-right: 6px;
    font-size: 16px;
    vertical-align: middle;
  }
  span {
    vertical-align: middle;
  }
}
.companybox:hover .view-hint {
  opacity: 1;
}
</style>

<!-- 非 scoped 样式：el-image 内部元素需全局样式才能生效 -->
<style lang="scss">
.culture .companybox .el-image {
  width: 100%;
  display: block;
}
.culture .companybox .el-image .el-image__inner {
  width: 100%;
  transform: scale(1.1);  /* 保持原有轻微放大裁切效果 */
}
</style>
